module.exports = __webpack_public_path__ + "img/step1.c0daaf49.png";